import React, { useState, useEffect } from "react";
import { slice } from "lodash";
import { useParams } from 'react-router-dom';
//import {Link} from 'react-router-dom';
import InnerBanner from '../components/InnerBanner'; 
import Accordion from 'react-bootstrap/Accordion';
import HotDestinations from '../home/HotDestinations';
import Helmet from "react-helmet";

export default function PackageDetailCraft() {
  const params = useParams();
  
    const [apilink] = useState(
        "/databases/packagesCraft.json"
      );
      //const [apilink, setApilink] = useState([])
      const [post, setPost] = useState([]);
   //const [ setIsCompleted] = useState(false);
      const [index] = useState();
      let initialPosts = slice(post, 0, index);
      const getData = (apilink) => {
        fetch(apilink)
          .then((res) => res.json())
          .then((json) => setPost(json))
          .catch((e) => console.log(e));
      };

      useEffect(() => {
        getData(apilink);
      }, [apilink]);

       initialPosts = initialPosts.filter(item => item.destinationname === params.loc);
  return (
    <>
      {initialPosts.map((item, i) => {
          
          
          return ( 
            <React.Fragment key={item.id}>
            
         {

          
        item.packages.map((itemm, j) => {
          
          if(itemm.pack_url === params.pack_url){
   
          return ( 
            <>
             <Helmet>
         
               <title>{itemm.det_page_data[0].titledet}</title>
     
             </Helmet>
    <InnerBanner imgPath={item.listing_page_banner} innerTitle={itemm.packname} />
     
     <section className="allPackages">
        <div className="container">
            <div className="row">
           
           
             
            <div className="col-8"> 
                <div className="packDetailpage">
                  <h1>{itemm.det_page_data[0].heading1}</h1>
                  <p>{itemm.det_page_data[0].content}</p>
                  
                  <Accordion defaultActiveKey="1">
                {    
                  itemm.det_page_data[0].accordion.map((acc, a) => 
                    
                    (
                      
                      <Accordion.Item eventKey={acc.id}>
                          <Accordion.Header>{acc.q1}</Accordion.Header>
                          <Accordion.Body>
                              {acc.a1}
                          </Accordion.Body>
                     </Accordion.Item>
                     ))
                     
                    }
    
    </Accordion>
                </div>
                
            </div>
            
            
 
            <div className="col-md-4">
                <h2>You May Like</h2>
                <HotDestinations cls="col-md-12"/>
              </div>
            </div>
        </div>
     </section>
     </>
);}
})
}
        </React.Fragment>
  );
})}

    </>
  )
}
